export default {
  lucky: {
    prizeAgain: 'फिर से घुमाएँ',
    prizeThanks: 'अगली बार भाग्य आज़माएँ',
    remainingChance: 'शेष मौके',
    task: 'कार्य',
    deposit: 'जमा',
    wager: 'दाँव',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'कार्ड संग्रह',
    puzzleRound: 'राउंड {current}/{total}',
    puzzleReward: 'पूरा करने पर पुरस्कार {amount}',
    redeem: 'रिडीम करें',
    redeemSuccess: 'सफलतापूर्वक रिडीम किया गया',
    redeemSuccessWithReward: 'सफलतापूर्वक रिडीम किया गया! आपको {amount} {currency} मिला',
    redeemFailed: 'रिडीम विफल',
    notComplete: 'अभी पूरा नहीं हुआ, रिडीम नहीं कर सकते',
    drawFailed: 'ड्रॉ विफल, कृपया पुनः प्रयास करें',
    gainLetter: 'बधाई हो! आपको अक्षर {letter} मिला',
    gainBlock: 'बधाई हो! आपको चित्र {blockNo} मिला',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'आमंत्रित करें',
    claimReward: 'प्राप्त करें',
    noChest: 'कोई संदूक नहीं',
    claimSuccess: '{count} संदूक प्राप्त किए, {amount} {currency}',
    modalTitle: 'खजाना संदूक',
    modalSubtitle: 'सभी देखने के लिए स्वाइप करें',
    chipTodayClaimed: 'आज प्राप्त',
    chipClaimable: 'प्राप्त करने योग्य',
    chipLocked: 'बंद',
    totalClaimedCount: 'कुल प्राप्त संदूक',
    totalClaimedAmount: 'कुल प्राप्त राशि',
    chestUnit: 'पीसी',
    claimAll: 'सभी प्राप्त करें',
    goInvite: 'दोस्तों को आमंत्रित करें',
    claimSingleSuccess: '{amount} {currency} प्राप्त किया',
    labelClaimed: 'प्राप्त',
    labelClaimable: 'प्राप्त करने योग्य',
    labelLocked: 'बंद',
  },
}
